import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { PromoBar } from "@/components/PromoBar";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/bundle", label: "Bundle" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const { settings } = useStore();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const brand = settings?.brand_name || "UpgradeMate";

  return (
    <header className="sticky top-0 z-50">
      <PromoBar />
      <div className="glass border-b border-black/5">
        <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
          <Link to="/" data-testid="nav-logo" className="font-logo text-2xl">
            {brand}<span className="text-muted-foreground">.</span>
          </Link>

          <div className="hidden items-center gap-8 md:flex">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm transition-colors hover:text-foreground ${isActive ? "text-foreground" : "text-muted-foreground"}`}>
                {l.label}
              </NavLink>
            ))}
          </div>

          <div className="hidden md:block">
            <Button data-testid="nav-shop-cta" onClick={() => navigate("/shop")}
              className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 px-6">Shop PDFs</Button>
          </div>

          <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </nav>

        {open && (
          <div className="border-t border-black/5 bg-white px-5 py-4 md:hidden" data-testid="nav-mobile-menu">
            <div className="flex flex-col gap-3">
              {links.map((l) => (
                <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}
                  className="text-base text-foreground" data-testid={`nav-mobile-${l.label.toLowerCase()}`}>{l.label}</NavLink>
              ))}
              <Button onClick={() => { setOpen(false); navigate("/shop"); }} className="mt-2 rounded-none bg-primary text-primary-foreground">Shop PDFs</Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
